/**
 * Feature Gate Utility
 * Maps dashboard sections to required feature flags
 * Used to hide/show navigation items based on enabled modules
 */

/**
 * Maps tab IDs to required feature flags
 * If any flag in the array is true, the tab is shown
 */
export const TAB_FEATURE_MAP = {
  // Core PMS tabs - require PMS enabled
  'rooms': ['pms_enabled'],
  'bookings': ['pms_enabled'],
  'room-board': ['pms_enabled'],
  'housekeeping': ['pms_enabled'],
  'availability': ['pms_enabled'],
  'pricing-discounts': ['pms_enabled'],
  'meeting-rooms': ['pms_enabled'],
  
  // Staff tabs - require staff management
  'staff': ['staff_management_enabled'],
  'payroll': ['staff_management_enabled'],
  
  // AI-related tabs
  'ai-mcp': ['ai_bitsy_enabled', 'ai_marina_enabled', 'ai_sage_enabled'],
  
  // Always visible tabs (no feature requirement)
  'overview': [],
  'front-desk': [],
  'guest-issues': [],
  'requests': [],
  'reports': [],
  'billing': [],
  'telegram': [],
  'widget': [],
  'feature-settings': [],
  'settings': [],
  'data-export': []
};

/**
 * Check if a tab should be visible based on hotel's enabled features
 * @param {string} tabId - The navigation tab ID
 * @param {object} hotelFeatures - Hotel's feature configuration
 * @returns {boolean} - Whether the tab should be visible
 */
export function isTabVisible(tabId, hotelFeatures) {
  // If no feature requirements, always visible
  const requiredFeatures = TAB_FEATURE_MAP[tabId];
  if (!requiredFeatures || requiredFeatures.length === 0) {
    return true;
  }
  
  // If any required feature is enabled, show the tab
  return requiredFeatures.some(feature => hotelFeatures?.[feature] === true);
}

/**
 * Filter navigation items based on enabled features
 * @param {array} navItems - All navigation items
 * @param {object} hotelFeatures - Hotel's feature configuration
 * @returns {array} - Filtered navigation items
 */
export function filterNavItems(navItems, hotelFeatures) {
  if (!hotelFeatures) {
    return navItems; // Show all if features not loaded yet
  }
  
  return navItems.filter(item => isTabVisible(item.id, hotelFeatures));
}
